import { Button } from 'components/ui'
import React, { useContext } from 'react'
import { BsPlay, BsPlayBtn, BsPlayCircle, BsStars } from 'react-icons/bs'
import { HiSparkles } from 'react-icons/hi'
import { HiOutlineSparkles } from 'react-icons/hi2'
import { LuWand, LuWand2 } from 'react-icons/lu'
import AIPriceBadge from 'components/shared/AIPriceBadge'
import { AIContext } from 'contexts/AIContext'

const AIVideoGenerateButton = ({ isLoading, query, generateVideo, model, duration = 8 }) => {
    const { aiModels } = useContext(AIContext);

    // Get video model pricing
    const videoModel = aiModels.find(m => m.model === model && m.type === 'video');
    const videoPrice = videoModel?.price || 0;
    const isPricePerSecond = videoModel?.isPricePerSecond || false;
    const quantity = isPricePerSecond ? duration : 1;

    const isDisabled = !query?.trim() || isLoading;

    return (
        <Button
            variant="ai"
            size="md"
            onClick={generateVideo}
            loading={isLoading}
            disabled={isDisabled}
            className="!bg-gradient-to-r !from-purple-600 !to-blue-600 hover:!from-purple-700 hover:!to-blue-700 !text-white !border-0 shadow-lg hover:shadow-xl transition-all duration-200 w-full"
            icon={isLoading ? <HiSparkles className="animate-spin" /> : <HiOutlineSparkles />}
        >
            <span className="flex items-center gap-2">
                <span>{isLoading ? 'Generating...' : 'Generate Video'}</span>
                {!isLoading && query?.trim() && (
                    <AIPriceBadge
                        price={videoPrice}
                        quantity={quantity}
                        priceType={isPricePerSecond ? 'second' : 'generation'}
                        size="sm"
                        variant="purple"
                        className="!bg-white/20 !text-white !border-white/30"
                    />
                )}
            </span>
        </Button>
    )
}

export default AIVideoGenerateButton
